
import { Options, Vue } from 'vue-class-component';
import mapConfig from "@/config/map";
import RegionService from "@/services/RegionService";
import NavigationService from '@/services/NavigationService';
import { OptionalDistanceRegion, RegionManager } from "@/data/region";
import RegionCourses from "@/components/RegionCourses.vue";


@Options({
    props: {
        regionId: {
            type: Number,
            required: false,
        },
        region: {
            type: Object,
            required: false,
            default: null,
        },
        /*showCoursesButton: {
            type: Boolean,
            required: false,
            default: false,
        },*/
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        RegionCourses,
    },
    emits: [
        'close',
    ]
})
export default class RegionCoursesModal extends Vue {
    regionId: number|null = null
    region: OptionalDistanceRegion|null = null
    regionLocal: OptionalDistanceRegion|null = null
    shown!: boolean
    //showCoursesButton = false

    regionStale = true

    loading = false

    closeModal() {
        this.$emit('close');
    }

    loadRegion() {
        this.loading = true;
        return RegionService.getRegion(this.regionId as number).then(result => {
            this.regionLocal = result.data?.data;
        }).finally(() => this.loading = false);
    }

    /*getRegisterUrl(courseId: number) {
        return this.regionLocal ? NavigationService.buildRouteUrl('register', { region: this.regionLocal.id, course: courseId }) : '#';
    }*/

    mounted() {
        this.$watch('region', (newRegion: OptionalDistanceRegion|null) => {
            this.regionLocal = JSON.parse(JSON.stringify(newRegion));
        }, { immediate: true });

        this.$watch('regionId', (newRegionId: number|null) => {
            this.regionStale = true;
            /*if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }*/
        }, { immediate: true });

        this.$watch('shown', (newShown: boolean) => {
            if( newShown && this.regionStale ) {
                this.loadRegion();
                this.regionStale = false;
            }
        });
    }
}
